var Backbone, SharedAjaxErrorTemplate, SharedAjaxErrorView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

SharedAjaxErrorTemplate = require('../../ajax_error.html.mustache');

SharedAjaxErrorView = (function(superClass) {
  extend(SharedAjaxErrorView, superClass);

  function SharedAjaxErrorView() {
    return SharedAjaxErrorView.__super__.constructor.apply(this, arguments);
  }

  SharedAjaxErrorView.prototype.initialize = function() {
    this.I18nScope = 'modules.shared';
    return this.template = SharedAjaxErrorTemplate;
  };

  SharedAjaxErrorView.prototype.render = function(hash) {
    if ((hash != null ? hash.container : void 0) != null) {
      this.$container = hash.container;
      this.$container.html(toHtml(this.template, hash, this.I18nScope));
      this.bindEvents();
      return this.$container;
    }
  };

  SharedAjaxErrorView.prototype.bindEvents = function() {
    return $(".error_reload", this.$container).on("click", function() {
      return window.location.reload();
    });
  };

  return SharedAjaxErrorView;

})(Backbone.View);

module.exports = SharedAjaxErrorView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUva3VtYXJyYS9uYXBpc3RyYW5vL2J1aWxkLzE1MDQ3NzgxNDM1MjYtNzYxNzcvcHJvZHVjdGlvbi0yMDE3LjA5LjA3XzA5LjU0L3N1cHBvcnRfYXBwL21vZHVsZXMvc2hhcmVkL2Zyb250ZW5kL3ZpZXdzL2FqYXhfZXJyb3Jfdmlldy5jb2ZmZWUiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIvdmFyL2dyb3Vwb24vaG9tZS9rdW1hcnJhL25hcGlzdHJhbm8vYnVpbGQvMTUwNDc3ODE0MzUyNi03NjE3Ny9wcm9kdWN0aW9uLTIwMTcuMDkuMDdfMDkuNTQvc3VwcG9ydF9hcHAvbW9kdWxlcy9zaGFyZWQvZnJvbnRlbmQvdmlld3MvYWpheF9lcnJvcl92aWV3LmNvZmZlZSJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFBLHNEQUFBO0VBQUE7OztBQUFBLFFBQUEsR0FBVyxPQUFBLENBQVEsVUFBUjs7QUFDWCxRQUFRLENBQUMsQ0FBVCxHQUFhOztBQUNiLHVCQUFBLEdBQTBCLE9BQUEsQ0FBUSxnQ0FBUjs7QUFFcEI7Ozs7Ozs7Z0NBRUosVUFBQSxHQUFhLFNBQUE7SUFDWCxJQUFDLENBQUEsU0FBRCxHQUFhO1dBQ2IsSUFBQyxDQUFBLFFBQUQsR0FBWTtFQUZEOztnQ0FJYixNQUFBLEdBQVMsU0FBQyxJQUFEO0lBQ1AsSUFBRyxnREFBSDtNQUNFLElBQUMsQ0FBQSxVQUFELEdBQWMsSUFBSSxDQUFDO01BQ25CLElBQUMsQ0FBQSxVQUFVLENBQUMsSUFBWixDQUFpQixNQUFBLENBQU8sSUFBQyxDQUFBLFFBQVIsRUFBa0IsSUFBbEIsRUFBd0IsSUFBQyxDQUFBLFNBQXpCLENBQWpCO01BQ0EsSUFBQyxDQUFBLFVBQUQsQ0FBQTthQUNBLElBQUMsQ0FBQSxXQUpIOztFQURPOztnQ0FPVCxVQUFBLEdBQWEsU0FBQTtXQUNYLENBQUEsQ0FBRSxlQUFGLEVBQWtCLElBQUMsQ0FBQSxVQUFuQixDQUE4QixDQUFDLEVBQS9CLENBQWtDLE9BQWxDLEVBQTBDLFNBQUE7YUFDeEMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxNQUFoQixDQUFBO0lBRHdDLENBQTFDO0VBRFc7Ozs7R0FibUIsUUFBUSxDQUFDOztBQWtCM0MsTUFBTSxDQUFDLE9BQVAsR0FBaUIifQ==
